import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import router from './router'
import store from './store'
import Icon from 'vue-svg-icon/Icon.vue'
import { userInfo } from '@/common/request'
import { useRouter, useRoute } from 'vue-router'
import toast from '@/common/functions/toast'

router.beforeEach(async (to, from, next) => {
    const user: any = store.state.userInfo
    const path = from.path
    const toPath = to.path
    const router = useRouter()
    if (path === toPath) {
        return
    }
    // 无任何权限
    if (toPath === '/401') {
        next()
        return
    }
    if (toPath === '/502') {
        next()
        return
    }

    // 登录页不要请求 info.json
    if (toPath === '/login') {
        next()
    } else {
        if (!(user && user.name)) {
            /**
             * 获取用户的基本信息
             */
            try {
                const { data } = await userInfo({})
                store.commit('setUserInfo', data)
                next()
            } catch (e) {
                console.error(e)
            }
            return
        } else {
            next()
        }
    }
})
const app = createApp(App)
let win: any = window
win.toast = toast
app.use(Antd)
app.use(router)
app.use(store)
app.component('Icon', Icon)
app.mount('#app')
